import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcUser = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18.5407 15.0974C19.0257 15.495 19.3013 16.081 19.3013 16.7107V18.4919C19.3013 18.9511 18.9323 19.3201 18.4731 19.3201C18.011 19.3201 17.6391 18.9454 17.656 18.4974V16.7159C17.656 16.5855 17.5989 16.4638 17.499 16.3827C16.8135 15.8202 16.0539 15.2995 15.2673 14.8295C14.7489 14.5197 14.3041 14.2813 13.9553 14.1098C13.6303 13.9475 13.4265 13.62 13.4265 13.2599V10.7534C13.4265 10.4743 13.5645 10.2145 13.793 10.0674C13.8911 10.0011 13.9492 9.89192 13.9492 9.77733V7.17473C13.9492 6.34109 13.2709 5.66147 12.4359 5.66147H11.8757C11.0422 5.66147 10.3625 6.33968 10.3625 7.17473V9.77733C10.3625 9.89504 10.4187 9.99973 10.5171 10.0664C10.7452 10.2187 10.8851 10.478 10.8851 10.7534V13.2599C10.8851 13.6219 10.6791 13.951 10.3551 14.1051C10.0075 14.2761 9.56284 14.5144 9.04441 14.8242C8.25785 15.2942 7.4984 15.8149 6.81182 16.3782C6.7129 16.4585 6.656 16.5799 6.656 16.7107V18.4919C6.656 18.951 6.28682 19.3201 5.82787 19.3201C5.36887 19.3201 5 18.951 5 18.4919V16.7107C5 16.0811 5.27555 15.4951 5.75975 15.0979C6.87389 14.1798 8.09732 13.4116 9.22393 12.8215V11.12C8.88873 10.7513 8.70127 10.2744 8.70127 9.77187V7.16927C8.70127 5.42314 10.1226 4 11.8705 4H12.4305C14.1765 4 15.6 5.42149 15.6 7.16927V9.77187C15.6 10.2742 15.4124 10.7512 15.0773 11.1199V12.8215C16.2034 13.4113 17.4271 14.1797 18.5407 15.0974Z",
		fill: "#3A3C45"
	})]
});
const ForwardRef = forwardRef(SvgIcUser);
export default ForwardRef;
